import axios, { Canceler } from 'axios'
import {
  IJourneyByIdRespDto,
  IJourneyCreateDto,
  IJourneysAllRawRespDto,
  IJourneysRespDto,
  IJourneyUpdateDto,
} from 'src/types'
import { EnhancedWithAuthHttpService } from './http-auth.service'
import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import { ICancelRemovalDto, IMessageResponseDto } from 'src/types'

class JourneyDataService extends EnhancedWithAuthHttpService {
  CancelToken
  cancel?: Canceler
  allRawJourneysCancel?: Canceler

  constructor() {
    super(new HttpService(axiosInstance))
    this.CancelToken = axios.CancelToken
  }
  async createJourney(dto: IJourneyCreateDto) {
    return await this.post<string, IJourneyCreateDto>(`journeys`, dto)
  }

  async getJourneyById(id: string, locale: string) {
    return await this.get<IJourneyByIdRespDto>(`journeys/${id}/${locale}`)
  }

  async editJourney(dto: IJourneyUpdateDto, id: string) {
    return await this.put<string, IJourneyUpdateDto>(`journeys/${id}`, dto)
  }

  async removeJourneys(ids: string[]) {
    return await this.delete<string>(`journeys`, { data: { ids } })
  }

  cancelRemove(params: ICancelRemovalDto) {
    return this.get<IMessageResponseDto>('journeys/cancel-deletion', { params })
  }

  async getAllRawJourneys(params?: {}) {
    if (this.allRawJourneysCancel) {
      this.allRawJourneysCancel()
    }

    return await this.get<IJourneysAllRawRespDto>(`journeys/all/raw`, {
      params,
      cancelToken: new this.CancelToken((c) => {
        this.allRawJourneysCancel = c
      }),
    })
  }

  async getJourneys(params?: {}) {
    return await this.get<IJourneysRespDto>(`journeys`, { params })
  }

  async getFilteredJourneys(params?: {}) {
    if (this.cancel) {
      this.cancel()
    }

    return await this.get<IJourneysRespDto>(`journeys`, {
      params,
      cancelToken: new this.CancelToken((c) => {
        this.cancel = c
      }),
    })
  }

  checkCodeExist(code: string, id?: string, accountId?: string) {
    return this.get<IMessageResponseDto>(`journeys/code/${code}`, {
      params: { accountId, id },
    })
  }

  getInitialCode(accountId?: string) {
    const res = this.get<string>(`journeys/code/initial`, { params: { accountId } })
    return res
  }

  removeStepFromOrder(stepIds:string[], journeyArr: string[]){
    return this.post('journeys/remove-step-from-order', {idsArr: stepIds, journeysArr: journeyArr})
  }
}

const JourneyService = new JourneyDataService()
export default JourneyService
